module.exports = __webpack_public_path__ + "static/media/editor-scratch.d2b50346.svg";